// extracted by mini-css-extract-plugin
export default {"userBigData":"styles_userBigData__-q1dH","title":"styles_title__UViQl","text":"styles_text__zobwy"};